<template>
  <div class="wrap">
    <video
      class="loadingVideo video-bg2 video-size"
      muted
      autoplay
      id="media"
      v-if="preNumParams"
      ref="videoPlayer"
      @ended="videoEnded"
    >
      <source
        src="https://resource-mp4.ujoygames.com/reso_en/bg.mp4"
        type="video/mp4"
      />
    </video>
    <div v-else>
      <div class="nav" :class="!preParams ? 'hidenavbg' : ''">
        <div class="game-logo" v-if="!preParams">
          <img
            :src="require('../assets/img/nav/logo/game-logo-' + lang + '.png')"
            alt=""
            srcset=""
          />
        </div>
        <div v-else>
          <div class="menu">
            <div class="filterMenu" v-for="(item, idx) in navlist" :key="idx">
              <ul class="header-nav_list" v-if="item.lang == lang">
                <li
                  class="header-nav_item"
                  v-for="Mitem in item.list"
                  :key="Mitem.id"
                  @click="handleNav(Mitem)"
                >
                  <img
                    :src="activeIndex == Mitem.id ? Mitem.activeUrl : Mitem.url"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div class="share-icon">
            <div class="tt" @click="tt_page('tt')"></div>
            <div class="fb-icon" @click="fb_page('fb')"></div>
            <div class="ds" @click="Discord_page('ds')"></div>
            <div class="ytb" @click="youtube_page('yt')"></div>
            <div class="x-icon" @click="Twitter_page('twi')"></div>
          </div>
        </div>
      </div>

      <div class="page">
        <swiper
          :options="swiperOption"
          ref="goodSwiper"
          @slideChange="slideChange"
        >
          <swiper-slide>
            <layer1 @handleVideo="videoFlag = true" />
          </swiper-slide>
          <!-- <swiper-slide v-if="preParams">
            <layer2 />
          </swiper-slide> -->
          <swiper-slide v-if="preParams">
            <layer3 />
          </swiper-slide >
          <swiper-slide v-if="preParams">
            <layer4 />
          </swiper-slide>
          <swiper-slide v-if="preParams">
            <layer5 />
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <!-- 首页视频 -->
    <div
      v-if="videoFlag"
      class="model position-fixed"
      @click="videoFlag = false"
    >
      <div class="v-txt">
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/zGBzDtzEZ54?si=o4Fop5NFvw13RbFj"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import layer1 from "./publicComponents/layer1";
// import layer2 from "./publicComponents/layer2";
import layer3 from "./publicComponents/layer3";
import layer4 from "./publicComponents/layer4";
import layer5 from "./publicComponents/layer5";

export default {
  components: {
    layer1,
    // layer2,
    layer3,
    layer4,
    layer5
  },
  data() {
    return {
      preParams: true, // 和落地页进行判断
      preNumParams: true,
      lang: "en",
      activeIndex: 1,
      // menu
      navlist: [
        {
          lang: "en",
          list: [
            {
              id: 1,
              url: require("../assets/img/nav/nav-en/1.png"),
              activeUrl: require("../assets/img/nav/nav-en/1-active.png")
            },
            // {
            //   id: 2,
            //   url: require("../assets/img/nav/nav-en/2.png"),
            //   activeUrl: require("../assets/img/nav/nav-en/2-active.png")
            // },
            {
              id: 2,
              url: require("../assets/img/nav/nav-en/3.png"),
              activeUrl: require("../assets/img/nav/nav-en/3-active.png")
            },
            {
              id: 3,
              url: require("../assets/img/nav/nav-en/4.png"),
              activeUrl: require("../assets/img/nav/nav-en/4-active.png")
            },
            {
              id: 4,
              url: require("../assets/img/nav/nav-en/5.png"),
              activeUrl: require("../assets/img/nav/nav-en/5-active.png")
            }
          ]
        }
      ],
      // videoPlayTime: false, // 视频播放

      videoFlag: false,
      nextShow: true,
      swiperOption: {
        allowTouchMove: false,
        direction: "horizontal",
        mousewheel: true, //开启鼠标
        speed: 1100, //滚动速度
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        noSwiping: false,
        noSwipingClass: "stop-swiping",
        initialSlide: 0
      },
      eventsAuto: false
    };
  },
  created() {
    let videoPlayer = this.$refs.videoPlayer;
    // if (this.videoPlay) {
    //   videoPlayer.muted = false;
    // }
    this.getPre();
  },
  updated() {},

  mouthed() {},
  watch: {},
  computed: {},
  methods: {
    getPre() {
      let pre = "";
      let url = window.location.search;
      let preParam =
        url.indexOf("pre") >= 0
          ? this.common.getUrlParam("pre")
          : this.common.getUrlParam("pre");
      pre = preParam || "";
      if (url.indexOf("pre")) {
        if (pre == 1 || pre == "pc_1" || pre == "pc_2" || pre == "pc_3") {
          this.preNumParams = false;
        } else {
          this.preNumParams = true;
        }

        if (pre == "pc_1" || pre == "pc_2" || pre == "pc_3") {
          this.preParams = false;
        } else {
          this.preParams = true;
        }
      }else {
      
      }
    },

    // 菜单
    handleNav(val) {
      this.activeIndex = val.id;
      const hcon = this.$refs.goodSwiper.swiper;
      if (val.id == 1) {
        hcon.slideTo(0, 300);
      }
      if (val.id == 2) {
        hcon.slideTo(1, 300);
      }
      if (val.id == 3) {
        hcon.slideTo(2, 300);
      }
      if (val.id == 4) {
        hcon.slideTo(3, 300);
      }
      if (val.id == 5) {
        hcon.slideTo(4, 300);
      }
    },
    tt_page(val) {
      this.common.goShare(val);
    },
    Twitter_page(val) {
      this.common.goShare(val);
    },
    Discord_page(val) {
      this.common.goShare(val);
    },
    fb_page(val) {
      this.common.goShare(val);
    },
    youtube_page(val) {
      this.common.goShare(val);
    },

    videoEnded() {
      this.preNumParams = false;
    },

    slideChange() {
      const mainActiveIndex = this.$refs.goodSwiper.swiper.activeIndex;
      this.activeIndex = mainActiveIndex + 1;
    }
  }
};
</script>
<style lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #000;
  .hidenavbg {
    background: none;
  }
  .loadingVideo {
    position: absolute;
    z-index: 99;
  }

  // 轮播

  .page {
    .swiper-container {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainIndex.vue